export default __webpack_public_path__ + "static/button-action-do-light-0521af26a946de0b00a04cae120bb744.png";